import React, { useRef } from "react";

const AcceptGuarantorship = ({
  id_R,
  isAcceptGuarantorship,
  selectedGuarantor,
  closeAcceptGuarantorship,
  guaranteeAmount,
  setGuaranteeAmount,
  uploadeDocfile,
  setUploadeDocfile,
  handleSubmitGuarantorResponseAccepted,
}) => {
  const fileInputFront = useRef(null);

  const openFrontFilePicker = () => {
    fileInputFront.current.click();
  };

  const handlePhotoFileChange = (e) => {
    const file = e.target.files[0];
    setUploadeDocfile(file);
  };

  const isFormComplete =
    guaranteeAmount.trim() !== "" && uploadeDocfile !== null;

  const handleAmountChange = (e) => {
    const value = e.target.value;

    // allow only numbers
    if (/^\d*$/.test(value)) {
      setGuaranteeAmount(value);
    }
  };

  const truncateFileName = (fileName) => {
    const maxLength = 12;
    const extensionIndex = fileName.lastIndexOf(".");
    const nameWithoutExtension = fileName.substring(0, extensionIndex);
    const truncatedName =
      nameWithoutExtension.length > maxLength
        ? `${nameWithoutExtension.substring(0, maxLength)}...`
        : nameWithoutExtension;
    return `${truncatedName}.${fileName.substring(extensionIndex + 1)}`;
  };
  return (
    <>
      <div
        id={id_R}
        className={`${
          isAcceptGuarantorship ? "flex" : "hidden"
        } items-center justify-center fixed inset-0 z-50 overflow-auto bg-gray-800 bg-opacity-50`}
      >
        <div className="relative flex items-center fixed min-h-screen max-w-[100%] h-full md:h-auto">
          <div className="relative justify-end bg-white shadow max-w-[100%] mx-auto min-h-[80%] w-[60vw]">
            <div
              onClick={closeAcceptGuarantorship}
              className="absolute top-[5px] right-[10px] cursor-pointer text-[24px] flex items-center justify-center mt-2"
            >
              <svg
                width="12"
                height="12"
                viewBox="0 0 12 12"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M7.74039 11.1602L5.60039 8.06016L3.80039 11.1602H0.100391L3.78039 5.46016L0.000390632 0.000155687H3.84039L5.98039 3.08016L7.78039 0.000155687H11.4804L7.74039 5.62016L11.5804 11.1602H7.74039Z"
                  fill="black"
                />
              </svg>
            </div>
            <div className="p-5">
              <div className="flex items-center mt-10">
                <p className="text-[20px] font-bold text-[#000]">
                  Accept Guarantorship
                </p>
              </div>
              <p className="text-[#000] text-[15px] font-[300] mt-3">
                To complete guarantorship acceptance, attach the signed consent
                form and enter the amount the guarantor <br /> has agreed to
                guarantee.
              </p>

              <div className="flex items-center mt-10">
                <div className="flex w-[50%] flex-col">
                  <label htmlFor="firstname">Guarantor</label>
                  <div className="flex items-center rounded-[4px] bg-[#EAEAEA] w-[90%] h-[40px] px-[10px] mt-[5px] gap-5">
                    <p className="text-[#060606] text-[16px] font-[300]">
                      {selectedGuarantor?.name
                        ?.split(" ")
                        ?.map(
                          (nam) =>
                            nam?.charAt(0)?.toUpperCase() +
                            nam?.slice(1)?.toLowerCase()
                        )
                        ?.join(" ")}
                    </p>
                    <p className="text-[#06B217] text-[14px] font-[500]">
                      {selectedGuarantor?.memberID}
                    </p>
                  </div>
                </div>
                <div className="flex w-[50%] flex-col">
                  <label htmlFor="amount">Amount to Guarantee</label>
                  <div className="flex items-center w-[90%] h-[40px] mt-[5px] border border-[#8E8E8E] rounded-[4px] px-2">
                    <span className="text-[#060606] font-normal mr-3">KES</span>
                    <input
                      type="text"
                      value={guaranteeAmount}
                      onChange={handleAmountChange}
                      placeholder="Enter amount"
                      className="flex-1 h-full border-none outline-none text-[16px] font-normal text-[#060606]"
                    />
                  </div>
                </div>
              </div>
              <div className="flex w-[48%] flex-col justify-center mt-10">
                <label
                  htmlFor="genderSelect"
                  className="mb-1 text-md font-medium text-[#000]"
                >
                  Upload Guarantor Consent form
                </label>
                <div
                  onClick={openFrontFilePicker}
                  className="w-full h-[162px] rounded-[5px] mt-3 bg-[#EAEAEA] flex items-center justify-center flex-col cursor-pointer"
                >
                  <svg
                    width="45"
                    height="45"
                    viewBox="0 0 45 45"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M21.5625 29.2069V12.9881L17.1938 17.3569L15.8663 16.0106L22.5 9.375L29.1356 16.0106L27.8081 17.3588L23.4375 12.9881V29.2069H21.5625ZM12.405 35.625C11.5413 35.625 10.8206 35.3363 10.2431 34.7588C9.66562 34.1812 9.37625 33.46 9.375 32.595V28.0519H11.25V32.595C11.25 32.8838 11.37 33.1488 11.61 33.39C11.85 33.6313 12.1144 33.7512 12.4031 33.75H32.5969C32.8844 33.75 33.1488 33.63 33.39 33.39C33.6313 33.15 33.7512 32.885 33.75 32.595V28.0519H35.625V32.595C35.625 33.4588 35.3363 34.1794 34.7588 34.7569C34.1812 35.3344 33.46 35.6238 32.595 35.625H12.405Z"
                      fill="black"
                    />
                  </svg>
                  <input
                    type="file"
                    ref={fileInputFront}
                    onChange={handlePhotoFileChange}
                    style={{ display: "none" }}
                  />

                  <p className="text-#005C53B8 text-16 text-center">
                    {!uploadeDocfile ? (
                      <>
                        Drag and Drop or{" "}
                        <span style={{ color: "#06B217" }}>Choose file</span>{" "}
                        here
                      </>
                    ) : (
                      truncateFileName(uploadeDocfile.name)
                    )}
                  </p>

                  {uploadeDocfile && (
                    <p className="text-#005C53B8 w-90% truncate text-16 text-center">
                      {uploadeDocfile.type} (
                      {(uploadeDocfile.size / 1024).toFixed(2)} KB)
                    </p>
                  )}
                </div>
              </div>
              <div className="flex items-end justify-end h-[20vh]">
                <button
                  onClick={handleSubmitGuarantorResponseAccepted}
                  type="submit"
                  disabled={!isFormComplete}
                  className={`px-16 py-2 rounded-[6px] text-white font-medium cursor-pointer ${
                    isFormComplete ? "bg-[#005C53]" : "bg-[#D9D9D9]"
                  }`}
                >
                  Submit
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default AcceptGuarantorship;
